import { ofType } from 'redux-observable';
import { catchError, EMPTY, mergeMap, take } from 'rxjs';
import { RUN_REPORT } from '../../pages/insights/reports/report/report-actions/constants';
import { GENERATE_REPORT } from '../../services/pusher-service/pusher-contract-messages';
import { createPusherMessageCache } from '../pusher/message-cache';
import { GENERATE_REPORT_ASYNC } from './reports.actions';
import { downloadReport, downloadReportAsAttachment, generateReport } from './reports.api';

export const generateReportEpic = (action$) => {
  return action$.pipe(
    ofType(GENERATE_REPORT_ASYNC),
    mergeMap(({ body, action, onGenerationComplete, onError }) => {
      // Bind to Pusher BEFORE making the API call to avoid a race condition
      // where the Pusher message arrives before the HTTP response is processed.
      const { findMessage } = createPusherMessageCache(GENERATE_REPORT);

      return generateReport(body).pipe(
        mergeMap(({ jobGuids }) =>
          findMessage((pusherMessage) => jobGuids.includes(pusherMessage.messageGuid)).pipe(
            take(1),
            mergeMap((pusherMessage) => {
              const { file, error } = pusherMessage.data;

              if (error) {
                return onError(error);
              }

              if (action === RUN_REPORT) {
                return downloadReport(file).pipe(
                  mergeMap((response) => {
                    onGenerationComplete(response);
                    return EMPTY;
                  }),
                );
              }

              downloadReportAsAttachment(file);
              onGenerationComplete();

              return EMPTY;
            }),
          ),
        ),
        catchError((e) => {
          onError(e);
          return EMPTY;
        }),
      );
    }),
  );
};
